import { Grid, Divider, Typography, Paper, Box } from "@mui/material";
import { useHookFormContext } from "../../../../utils/hooks/useHookFormContext";
import { getGstAmount, getTotalAmount } from "../../../../pages/Calls/helpers";
import dayjs, { LocalDayjs } from "../../../../utils/timezoneService";
import { styled } from '@mui/material/styles';
import ExpandableField from "../../../../atoms/expandable-text-field/ExpandableTextField";

const FieldContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'baseline',
  marginBottom: theme.spacing(1),
}));

const FieldTitle = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  fontWeight: 600,
  color: theme.palette.text.primary,
  marginRight: theme.spacing(0.5),
}));

const FieldValue = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  fontWeight: 500,
  color: theme.palette.text.secondary,
}));

const ReadOnlyFields = () => {
  const { getValues } = useHookFormContext();
  const call = getValues('call_details');

  const gstin = call ? `${getGstAmount(call)} INR` : 'Not Applicable';
  const payableAmount = Number(getTotalAmount(call?.cost_price, call?.payable_mins, true, false));
  const exchangeRatePayable = call?.exchange_rate_payable;
  const isExchangeRatePayableValid = exchangeRatePayable !== null && exchangeRatePayable !== undefined;
  const payableAmountINR = (!isNaN(payableAmount) && isExchangeRatePayableValid) ? payableAmount * exchangeRatePayable : null;
  const RevenueINR = Number(call?.revenue_in_inr);
  const RevenueINRValue = !isNaN(RevenueINR) ? `${RevenueINR?.toFixed(0)} INR` : '';
  const RevenueUSD= Number(call?.revenue_in_usd)
  const RevenueUSDValue = !isNaN(RevenueUSD) ? `${RevenueUSD?.toFixed(0)} USD` : '';
  const ReviewedBy = call?.reviewed_by?.name ? ` - ${call?.reviewed_by?.name}` : '';
  const ReviewedOn = call?.reviewed_on ? ` on ${LocalDayjs(call?.reviewed_on).format("DD MMMM YYYY")}` : '';

  const fieldData = [
    {
      title: "Payable Amount:",
      value: !isNaN(payableAmount) ? `${payableAmount?.toFixed(0)} ${call?.cost_price_currency}` : '',
      isVisible: true
    },
    {
      title: "Payable Amount ₹:",
      value: payableAmountINR ? `${payableAmountINR?.toFixed(0)} INR` : '',
      isVisible: true
    },
    {
      title: "Revenue ₹:",
      value: RevenueINRValue,
      isVisible: true
    },
    {
      title: "Revenue $:",
      value: RevenueUSDValue,
      isVisible: true
    },
    {
      title: "GST Amount:",
      value: gstin,
      isVisible: true
    },
    {
      title: "Remark:",
      value: call?.remark || '',
      isVisible: true
    },
    {
      title: "Finance Remark:",
      value: call?.review_remarks
        ? `${call?.review_remarks}${ReviewedBy}${ReviewedOn}`
        : '',
      isVisible: true
    },
    {
      title: "15 CA:",
      value: call?.declaration_date ? LocalDayjs(call?.declaration_date)?.format("DD MMMM YYYY") : "",
      isVisible: true
    },
    {
      title: "Payment Date:",
      value: call?.transaction_meta?.payments?.map((payment: any) => 
        dayjs(payment?.payment_date).format('DD MMMM YYYY'))?.join(', ') || (call?.meta?.payment_date && dayjs(call?.meta?.payment_date).format('DD MMMM YYYY')) || null,
      isVisible: call?.transaction_meta?.payments || call?.meta?.payment_date
    },
  ];

  return (
    <Box sx={{ mx:2.5 }}>
    <Divider />
    <Grid container columnSpacing={4} rowSpacing={2} sx={{mt:1 }}>
      {fieldData.map((field, index) => (
        field.isVisible && (
          <Grid item xs={12} sm={6} key={index}>
            <FieldContainer>
              <FieldTitle>{field.title}</FieldTitle>
              <ExpandableField value={field?.value || ""} characterLimit={20} />
            </FieldContainer>
          </Grid>
        )
      ))}
    </Grid>
  </Box>

  );
};

export default ReadOnlyFields;